import React from 'react';
import "./PwaniMap.css";
import Pin from '../assets/pin.png';
import Mobpin from '../assets/mobpin.png';


function PwaniMap() {
  return (
    <div>
    <div className="map-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4690.33535485287!2d39.84397843269564!3d-3.6202864299787314!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x183fdd1315214717%3A0x663cfce7cf973e31!2sPwani%20University!5e0!3m2!1sen!2ske!4v1681719511461!5m2!1sen!2ske"
        title="Pwani University location on Google Maps"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
       <div className="map-title">
        <h1 style={{marginTop: "150px"}}>Pwani University</h1> <br />
          <img style={{width: "90px", height: "100px", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}} src={Pin} alt='google_pin' />
       
       
      </div>
    </div>
    <div className="map-title1">
        <h1 style={{marginTop: "150px", fontWeight: "lighter"}}>Pwani University</h1>
        <img className='pin' src={Pin} alt='google_pin' />
        <img className='mobpin' src={Mobpin} alt='google_pin' />
      </div>
    </div>
  );
}

export default PwaniMap;
